import { typographiesInterface } from "./typographies_interface";

export const Text1 = ({ className, children }: typographiesInterface) => (
  <p className={`${className} text-1-style`}>{children}</p>
);

export const Text2 = ({ className, text }: typographiesInterface) => (
  <p className={`${className} text-2-style `}>{text}</p>
);

export const Text3 = ({ className, text }: typographiesInterface) => (
  <p className={`${className} text-3-style`}>{text}</p>
);

export const Text4 = ({ className, text }: typographiesInterface) => (
  <p className={`${className} text-4-style `}>{text}</p>
);
export const Text5 = ({ className, text }: typographiesInterface) => (
  <p className={`${className} text-5-style `}>{text}</p>
);

export const Text6 = ({ className, text }: typographiesInterface) => (
  <p className={`${className} text-6-style`}>{text}</p>
);
